import { inject } from 'mobx-react';
import * as React from 'react';

import { RouteStore } from 'bernie-core';

import { AmenityViewModel } from 'models';

import { classNames } from 'uitk-react-utils';

import { Amenity } from './internals/amenity';

export interface AmenitiesListProps {
  amenities?: AmenityViewModel[];
  className?: string;
  routeStore?: RouteStore;
  small?: boolean;
  spacing?: string;
  title?: string;
  triggerDialogId?: string;
  unique?: string;
  useMiniDialog?: boolean;
}

export const AmenitiesList: React.FunctionComponent<AmenitiesListProps> = inject('routeStore')(
  ({ amenities, className, routeStore, small, spacing, title, triggerDialogId, unique, useMiniDialog }) => {
    const onDismiss = () => routeStore.goBack();
    const listClasses = classNames(className, 'amenities-list', {
      'uitk-type-200': small,
      'uitk-type-list-300 icon-m': !small
    });

    return (
      <ul className={listClasses}>
        {title && <h4 className="policies__section--text uitk-type-300 uitk-type-medium pwa-theme--grey-900">{title}</h4>}
        {amenities &&
          amenities.length > 0 &&
          amenities.map((amenity, index) => (
            <Amenity
              key={index}
              amenity={amenity}
              index={index}
              onDismiss={onDismiss}
              routeStore={routeStore}
              small={small}
              spacing={spacing}
              triggerDialogId={triggerDialogId}
              unique={unique}
              useMiniDialog={useMiniDialog}
            />
          ))}
      </ul>
    );
  }
);
